// import * as XLSX from "xlsx";
// import { jsPDF } from "jspdf";
// import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../components/common/notification/toaster_notify.component";

// // Copy functionality
// export const handleCopy = (data) => {
//     const textToCopy = data.map(item => item.stateName).join("\n");
//     navigator.clipboard.writeText(textToCopy).then(() => {
//         handleNotify("Data copied to clipboard", TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
//     }).catch(() => {
//         handleNotify("Failed to copy data", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
//     });
// };

// // Excel functionality
// export const handleExcel = (data) => {
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Inovee");
//     XLSX.writeFile(wb, "Inovee.xlsx");
// };

// // PDF functionality
// export const handlePDF = (data) => {
//     const doc = new jsPDF();
//     data.forEach((row, index) => {
//         doc.text(`${row.stateName} - ${row.isActive ? "Active" : "Inactive"}`, 10, 10 + (index * 10));
//     });
//     doc.save("Inovee.pdf");
// };

// // Print functionality
// export const handlePrint = () => {
//     window.print();
// };

import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../components/common/notification/toaster_notify.component";

// Copy functionality (all table data)
export const handleCopy = (data) => {
    try {
        if (!data || data.length === 0) {
            handleNotify("No data to copy", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
            return;
        }

        const headers = Object.keys(data[0]);
        const rows = data.map(item =>
            headers.map(h => item[h] ?? "").join("\t")
        );

        const textToCopy = [headers.join("\t"), ...rows].join("\n");

        navigator.clipboard.writeText(textToCopy).then(() => {
            handleNotify("Table data copied to clipboard", TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
        }).catch(() => {
            handleNotify("Failed to copy data", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        });
    } catch (error) {
        handleNotify("Copy error", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
    }
};

// Excel functionality
export const handleExcel = (data) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inovee");
    XLSX.writeFile(wb, "Inovee.xlsx");
};

// PDF functionality
export const handlePDF = (data) => {
    if (!data || data.length === 0) {
        handleNotify("No data to export", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        return;
    }
    const doc = new jsPDF("landscape");
    const headers = Object.keys(data[0]);
    const rows = data.map(item => headers.map(h => String(item[h] ?? "")));

    autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 20,
        styles: {
            fontSize: 8,
            cellPadding: 2,
            halign: "center",
            valign: "middle",
        },
        headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontStyle: "bold",
        },
        columnStyles: {
            0: { cellWidth: 30 },
        },
        didDrawCell: (data) => {
            if (data.cell && typeof data.cell.text === "string") {
                data.cell.styles.overflow = "linebreak";
            }
        },
    });

    doc.save("Inovee.pdf");
};

// Print functionality 
export const handlePrint = () => {
    window.print();
};
